import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Subscription } from '../types'
import stitchAxios from '../utils/axios'
import { AxiosResponse } from 'axios'

type SubscriptionStore = {
  subscriptions: Record<string, Subscription>,
  addSubscriptions: Function,
  fetchSubscription: (id: string) => Promise<void>,
  getSubscriptionsForMembership: (membershipId: string) => Promise<AxiosResponse<Subscription[]>>,
  cancelSubscription: (id: string, notify?: boolean) => Promise<void>,
  updateAutoRenew: (subscriptionId: string, status: 'on' | 'off', notify?: boolean) => Promise<any>,
  rehydrated: boolean,
  setRehydrated: Function
}

const createFunction = (set: Function, _: Function): SubscriptionStore => ({
  subscriptions: {},
  addSubscriptions: (subscriptions: Subscription[]) => {
    set((state: SubscriptionStore) => ({
      ...state,
      subscriptions: {
        ...state.subscriptions,
        ...Object.fromEntries(subscriptions.map((sub) => ([sub.id, sub])))
      }
    }))
  },
  fetchSubscription: async (_: string) => {
  },
  getSubscriptionsForMembership: async (membershipId: string) => {
    return await stitchAxios.get(`/memberships/${membershipId}/subscriptions`)
  },
  cancelSubscription: async (id: string, notify: boolean = true) => {
    await stitchAxios.post(`/subscriptions/${id}/cancel`, { notify })
    set((state: SubscriptionStore) => {
      const updatedSubscription = { ...state.subscriptions[id], status: 'canceled' }
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          [id]: updatedSubscription
        }
      }
    })
  },
  updateAutoRenew: async (subscriptionId: string, status: 'on' | 'off', notify: boolean = false) => {
    const response = await stitchAxios.post('/subscriptions/update_auto_renew', {
      subscription_id: subscriptionId,
      status,
      notify
    })
    // The response contains the updated subscription with auto_renew status
    return response.data
  },
  rehydrated: false,
  setRehydrated: (isRehydrated: boolean) => set({ rehydrated: isRehydrated })
})

export const useSubscriptionStore = create<SubscriptionStore>()(devtools(createFunction))

export default useSubscriptionStore
